import { Link } from "react-router-dom";
import TableUsers from "../../components/table/TableUsers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "react-bootstrap";
import { useState } from "react";

import { tr } from "../../i18n";
const UsersPage = () => {
  const [statusFilter, setStatusFilter] = useState("Active");
  const statusFilters = ["All", "Active", "Pending", "Inactive"];

  return (
    <div className="box-shadow">
      <Row>
        <Col lg={12} className="mb-4 mt-3">
          <Row>
            <Col lg={12}>
              <div className="d-flex flex-wrap gap-2 justify-content-between align-items-center">
                <div className="d-flex gap-2 flex-wrap">
                  {statusFilters.map((status) => (
                    <button
                      key={status}
                      type="button"
                      className={`btn btn-sm ${statusFilter === status ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => setStatusFilter(status)}
                    >
                      {tr(`shared:status_${status.toLowerCase()}`, { defaultValue: status })}
                    </button>
                  ))}
                </div>

                <div className="d-flex gap-3 justify-content-end">
                  <Link
                    to="/users/import"
                    className="btn btn-outline-primary d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm fw-small"
                  >
                    <FontAwesomeIcon icon={faUpload} />
                    {tr("users:import_users")}
                  </Link>
                  <Link to="/users/new" className="btn btn-primary float-right">
                    <FontAwesomeIcon icon={faPlus} />
                    {tr("users:new_user")}
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg={12}>
          <TableUsers statusFilter={statusFilter} />
        </Col>
      </Row>
    </div>
  );
};

export default UsersPage;
